// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__12Idb","label":"Category_label__1RzLy","content":"Category_content__YvN02","header":"Category_header__2NBCe","location":"Category_location__uoR1B"};